import { motion } from 'framer-motion';
import { PROCESS } from '@/lib/data';

export const Process = () => {
    return (
        <section
            id="process"
            data-testid="process-section"
            className="relative bg-ink py-24 md:py-32"
        >
            <div className="px-6 md:px-12 lg:px-16">
                <div className="max-w-4xl mb-20">
                    <p className="text-xs uppercase tracking-[0.4em] text-gold mb-5">
                        The Method
                    </p>
                    <h2 className="font-serif text-bone text-4xl sm:text-5xl lg:text-6xl tracking-tighter font-light leading-[1.05]">
                        How we shoot a wedding{' '}
                        <span className="italic text-bone-dim">like a Netflix film.</span>
                    </h2>
                    <p className="mt-6 text-bone-dim text-base lg:text-lg max-w-2xl leading-relaxed font-light">
                        Three acts. One love story. We approach every wedding with the
                        discipline of a feature film crew — and the intimacy of a friend
                        you trusted with the camera.
                    </p>
                </div>

                <div className="space-y-24 md:space-y-32">
                    {PROCESS.map((p, idx) => (
                        <motion.div
                            key={p.step}
                            initial={{ opacity: 0, y: 60 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, margin: '-120px' }}
                            transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
                            data-testid={`process-step-${p.step}`}
                            className={`grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-16 items-center ${
                                idx % 2 === 1 ? 'lg:[&>*:first-child]:order-2' : ''
                            }`}
                        >
                            <div className="lg:col-span-7 relative aspect-[5/4] overflow-hidden">
                                <img
                                    src={p.image}
                                    alt={p.title}
                                    loading="lazy"
                                    className="absolute inset-0 w-full h-full object-cover"
                                />
                                {/* subtle film-grade only — image shines through */}
                                <div className="absolute inset-0 bg-gradient-to-t from-ink/30 via-transparent to-transparent pointer-events-none" />
                            </div>
                            <div className="lg:col-span-5">
                                <p className="font-serif italic text-gold text-7xl lg:text-8xl tracking-tighter font-light leading-none mb-4">
                                    {p.step}
                                </p>
                                <h3 className="font-serif text-bone text-3xl lg:text-4xl tracking-tighter font-light mb-5">
                                    {p.title}
                                </h3>
                                <p className="text-bone-dim text-base lg:text-lg font-light leading-relaxed">
                                    {p.body}
                                </p>
                            </div>
                        </motion.div>
                    ))}
                </div>
            </div>
        </section>
    );
};
